import React from "react";
import ServiceDirectoryPage from "@/pages/ServiceDirectoryPage";

export default function HireDigitalPage() {
  return (
    <ServiceDirectoryPage
      lockKind="digital"
      eyebrow="Hire digital"
      headline="Hire Gulf Coast digital talent."
    />
  );
}
